import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import {
  Button,
  Typography,
  TextField,
  Checkbox,
  FormControlLabel,
} from '@material-ui/core';
import Fade from 'react-reveal/Fade';
import {
  states,
  canadaStates,
  countries,
} from '../../shared/Mappings';
import { truncate } from '../../shared/Helpers';

const text = {
  sectionHeader: 'Stay in Touch with Nia',
  emailPermission: 'I agree to let Nia send me promotional emails and updates.',
};

const styles = theme => ({
  section: {
    width: '100%',
    backgroundColor: 'white',
    position: 'relative',
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(4),
    margin: '0 auto',
    minHeight: '30vh',
  },
  content: {
    width: '100%',
    [theme.breakpoints.up(900)]: {
      width: '900px',
    },
    margin: '0 auto',
    padding: theme.spacing(4),
    paddingBottom: 220,
    [theme.breakpoints.down(600)]: {
      paddingBottom: 554,
    },
  },
  sectionHeader: {
    fontSize: '2.125rem',
    textTransform: 'uppercase',
    textAlign: 'center',
    paddingBottom: theme.spacing(4),
  },
  infusionForm: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: '20vh',
  },
  infusionFieldInput: {
    margin: theme.spacing(1),
  },
  emailPermission: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    fontSize: '.8em',
  },
  formControlLabel: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  horizontalFields: {
    textAlign: 'center',
  },
});

class EmailContactSignup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      inf_field_FirstName: '',
      inf_field_LastName: '',
      inf_field_Email: '',
      inf_field_Country: '',
      inf_field_State: '',
      checked: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this.handleSelectCountry = this.handleSelectCountry.bind(this);
    this.handleSelectState = this.handleSelectState.bind(this);
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleCheck(e) {
    this.setState({ checked: e.target.checked });
  }

  handleSelectCountry(e) {
    // console.log(e.target.value);
    this.setState({
      inf_field_Country: e.target.value,
      inf_field_State: '',
    });
  }

  handleSelectState(e) {
    // console.log(e.target.value);
    this.setState({ inf_field_State: e.target.value });
  }

  render() {
    const {
      classes,
    } = this.props;
    const {
      inf_field_FirstName,
      inf_field_LastName,
      inf_field_Email,
      inf_field_Country,
      inf_field_State,
      checked,
    } = this.state;
    function canSubmit() {
      if (inf_field_FirstName !== '' && inf_field_Email !== '' && inf_field_LastName !== '' && checked) {
        return true;
      }
      return false;
    }
    return (
      <div className={classes.section}>
        <div className={classes.content}>
          <Fade>
            <Typography className={classes.sectionHeader} color="textSecondary" variant="h2">{text.sectionHeader}</Typography>
            <form acceptCharset="UTF-8" action="https://sp877.infusionsoft.com/app/form/process/9381acb994eee503ac6b0e05a1dfa39a" className={classes.infusionForm} id="inf_form_9381acb994eee503ac6b0e05a1dfa39a" method="POST">
              <input name="inf_form_xid" type="hidden" value="9381acb994eee503ac6b0e05a1dfa39a" />
              <input name="inf_form_name" type="hidden" value="General Email Sign Up&#a;Web Form Submitted" />
              <input name="infusionsoft_version" type="hidden" value="1.70.0.386234" />
              <div className={classes.horizontalFields}>
                <TextField
                  required
                  className={classes.infusionFieldInput}
                  id="inf_field_FirstName"
                  name="inf_field_FirstName"
                  placeholder="First Name *"
                  type="text"
                  variant="outlined"
                  value={inf_field_FirstName}
                  onChange={this.handleChange}
                />
                <TextField
                  required
                  className={classes.infusionFieldInput}
                  id="inf_field_LastName"
                  name="inf_field_LastName"
                  placeholder="Last Name *"
                  type="text"
                  variant="outlined"
                  value={inf_field_LastName}
                  onChange={this.handleChange}
                />
              </div>
              <TextField
                required
                className={classes.infusionFieldInput}
                id="inf_field_Email"
                name="inf_field_Email"
                placeholder="Email *"
                type="text"
                variant="outlined"
                value={inf_field_Email}
                onChange={this.handleChange}
              />
              <div className={classes.horizontalFields}>
                <TextField
                  id="inf_field_Country"
                  name="inf_field_Country"
                  select
                  className={classes.infusionFieldInput}
                  variant="outlined"
                  SelectProps={{
                    native: true,
                  }}
                  label="Country"
                  value={inf_field_Country}
                  onChange={this.handleSelectCountry}
                >
                  <option value="" disabled />
                  { countries.map((country) => {
                    if (country.name === 'Canada') {
                      return (
                        <React.Fragment key={country.code}>
                          <option key={country.code} value={country.name}>{truncate(country.name, 30)}</option>
                          <option key="-" value="-" disabled>--------------</option>
                        </React.Fragment>
                      );
                    }
                    return (
                      <option key={country.code} value={country.name}>{truncate(country.name, 30)}</option>
                    );
                  })}
                </TextField>
                { inf_field_Country === 'United States'
                  && (
                    <TextField
                      id="inf_field_State"
                      name="inf_field_State"
                      select
                      className={classes.infusionFieldInput}
                      variant="outlined"
                      SelectProps={{
                        native: true,
                      }}
                      label="State/Province"
                      value={inf_field_State}
                      onChange={this.handleSelectState}
                    >
                      <option value="" key="1" disabled />
                      {states.map((state) => <option key={state.abbreviation} value={state.name}>{state.name}</option>)}
                    </TextField>
                  )
                }
                { inf_field_Country === 'Canada'
                  && (
                    <TextField
                      id="inf_field_State"
                      name="inf_field_State"
                      select
                      className={classes.infusionFieldInput}
                      variant="outlined"
                      SelectProps={{
                        native: true,
                      }}
                      label="State / Province"
                      value={inf_field_State}
                      onChange={this.handleSelectState}
                    >
                      <option value="" key="1" disabled />
                      {canadaStates.map((state) => <option key={state.abbreviation} value={state.name}>{state.name}</option>)}
                    </TextField>
                  )
                }
                {inf_field_Country !== 'United States' && inf_field_Country !== 'Canada'
                  && (
                    <TextField
                      className={classes.infusionFieldInput}
                      id="inf_field_State"
                      name="inf_field_State"
                      placeholder="State / Province"
                      type="text"
                      variant="outlined"
                      value={inf_field_State}
                      onChange={this.handleChange}
                    />
                  )
                }
              </div>
              <FormControlLabel
                className={classes.formControlLabel}
                control={<Checkbox checked={checked} onChange={this.handleCheck} />}
                label={text.emailPermission}
              />
              <Button disabled={!canSubmit()} color="secondary" variant="outlined" size="large" className="infusion-recaptcha" id="recaptcha_9381acb994eee503ac6b0e05a1dfa39a" type="submit">Submit</Button>

            </form>
            <script async defer type="text/javascript" src="https://sp877.infusionsoft.app/app/webTracking/getTrackingCode" />
            <script async defer type="text/javascript" src="https://sp877.infusionsoft.com/resources/external/recaptcha/production/recaptcha.js?b=1.70.0.386234"></script>
            <script src="https://www.google.com/recaptcha/api.js?onload=onloadInfusionRecaptchaCallback&render=explicit" async="async" defer="defer"></script>
            <script async defer type="text/javascript" src="https://sp877.infusionsoft.com/app/timezone/timezoneInputJs?xid=9381acb994eee503ac6b0e05a1dfa39a"></script>
          </Fade>
        </div>
      </div>
    );
  }
}

EmailContactSignup.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(EmailContactSignup);
